import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import React from "react";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Header from "./Header";
import Footer from './Footer';
import { withRouter } from "react-router-dom";
import { Text } from "react-native";
import { ToastContainer, toast } from 'react-toastify';
import { VALIDATE_ROUTE, RETRY_ROUTE, NOT_FOUND_ROUTE } from './Constant';
import { AVAILABLE, REDEEMED, INVALID } from './Constant';
import { VALIDATE_API_ROUTE } from './Constant';
import { TITLE_REDEEMED_CODE } from './Constant';

class Codes extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            publisherCode: "",
            productName: "",
            productImage: "",
            productCode: "",
            pin: ""
        };
    }

    componentDidMount(){
        document.title = {TITLE_REDEEMED_CODE}.TITLE_REDEEMED_CODE;
        axios.get({VALIDATE_API_ROUTE}.VALIDATE_API_ROUTE + this.props.match.params.token).then(res => {
            if (res.status === 200) {
                if (res.data.status === {AVAILABLE}.AVAILABLE) {
                    this.props.history.push({VALIDATE_ROUTE}.VALIDATE_ROUTE + this.props.match.params.token);
                } else if (res.data.status === {INVALID}.INVALID) {
                    this.props.history.push({NOT_FOUND_ROUTE}.NOT_FOUND_ROUTE);
                } else if (res.data.status === {REDEEMED}.REDEEMED) {
                    this.setState({productName: res.data.productName, productImage: res.data.productImage, productCode: res.data.productCode, pin: res.data.pin});
                } else {
                    this.props.history.push({RETRY_ROUTE}.RETRY_ROUTE + this.props.match.params.token);
                }
            } else {
                this.props.history.push({NOT_FOUND_ROUTE}.NOT_FOUND_ROUTE);
            }
        }).catch(error => {
            // In our case, validate token receive any error just push to not found
            this.props.history.push({NOT_FOUND_ROUTE}.NOT_FOUND_ROUTE);
            // if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                // console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
            // } else if (error.request) {
                // The request was made but no response was received `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
                // console.log(error.request);
            // } else {
                // Something happened in setting up the request that triggered an Error
                // console.log('Error', error.message);
            // }
        })
    }

    copyToClipboard = (text) => {
        const ta = document.createElement("textarea");
        ta.innerText = text;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        ta.remove();
        toast.success("Copied !", {
            toastId: "once"
        });
    };

    render() {
        return (
            <div className="page-container">
                <ToastContainer closeOnClick pauseOnHover={false} autoClose={2000}/>
                <Header />
                <div className="text-center content-wrap">
                    <Container>
                        <Row className="code-row-style">
                            <Text style={{fontWeight: 'bold', color: '#7f7a7a', fontSize: '20px'}}>Here is your {this.state.productName} code:</Text>
                        </Row>
                        <Row className="code-row-style" style={{marginTop: '30px', backgroundColor: '#f2f2f2', borderRadius: '20px', padding: '2px'}}>
                            <Col xs={4} md={5} className="text-right">
                                <img className="vdsProductImgSm" src={this.state.productImage} alt={this.state.productCode} />
                            </Col>
                            <Col xs={8} md={7} className="text-left">
                                <Text style={{fontWeight: 'bold', fontSize: '18px', color: '#222222'}}>{this.state.pin}</Text>
                            </Col>
                        </Row>
                        <Row className="code-row-style" style={{marginTop: '30px'}}>
                            <Button onClick={() => this.copyToClipboard(this.state.pin)} className="code-button-style" variant="primary" size="lg">
                                <span style={{fontWeight: 'bold', color: 'white'}}>COPY CODE</span>
                            </Button>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        );
    }
}

export default withRouter(Codes);